import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { canInstall, triggerInstall } from "@/registerServiceWorker";

export default function PWAInstallButton() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    const on = () => setAvailable(true);
    const off = () => setAvailable(false);
    window.addEventListener("pwa-installable", on);
    window.addEventListener("pwa-installed", off);
    setAvailable(canInstall());
    return () => {
      window.removeEventListener("pwa-installable", on);
      window.removeEventListener("pwa-installed", off);
    };
  }, []);

  if (!available) return null;
  return (
    <Button
      onClick={triggerInstall}
      data-testid="pwa-install-btn"
      variant="outline"
      className="rounded-full h-8 px-3 text-xs gap-1"
    >
      <Download size={12} /> Install app
    </Button>
  );
}
